// extracted by mini-css-extract-plugin
module.exports = {"containerPagination":"pagination_containerPagination__1SIoI","active":"pagination_active__1f0Ni"};